module.exports = __webpack_public_path__ + "img/555-42dfb3.png";